export default __webpack_public_path__ + "../img/34c1dd9b4bc719712b35fb2dfdf2e203.png";